module.exports = __webpack_public_path__ + "static/media/nossa história.03bed748.jpeg";